@if (gallery().teaser?.uuid) {
  <div class="gallery-asset {{ shape() }}" [class.shadow]="shadow()" #el>
    <img
      [src]="gallery() | galleryTeaserUrl: el.clientWidth"
      [style.object-position]="gallery().teaser.uuid === gallery().cover.uuid ? gallery().cover.position : undefined"
      alt=""
    />
    <div class="remove-teaser dark">
      <button
        appButton
        name="remove-teaser"
        location="gallery-settings-dialog"
        color="hard-simple"
        height="1"
        shape="round"
        [iconButton]="true"
        (click)="removeTeaser()"
      >
        <app-svg src="/assets/icons/trash.svg"></app-svg>
      </button>
    </div>
  </div>
}
@if (!gallery().teaser?.uuid) {
  <label class="gallery-asset empty" for="teaser-upload">
    <input
      type="file"
      id="teaser-upload"
      accept="image/*"
      class="hidden-input"
      (change)="uploadTeaserEvent($event.target)"
    />
    @if (loading()) {
      <app-loading-indicator></app-loading-indicator>
    } @else {
      <app-svg src="/assets/icons/image-upload.svg"></app-svg>
    }
  </label>
}
